export default __webpack_public_path__ + "static/media/eq.8c812f7f.PNG";